<template>
  <div v-if="i18nLoaded" class="default">
    <div class="logo-wrapper">
      <LogoWithTitle />
    </div>
    <section class="section">
      <h1>
        <slot name="title" />
      </h1>
      <slot name="contents" />
    </section>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/shared/Footer";
import LogoWithTitle from "@/assets/logos/logo-with-title-black.svg";
import { mapGetters } from "vuex";

export default {
  name: "Default",
  components: {
    LogoWithTitle,
    Footer,
  },
  computed: {
    ...mapGetters({
      i18nLoaded: "i18n/i18nLoaded",
    }),
  },
};
</script>
<style lang="scss" scoped>
.default {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  height: 100vh;
  padding: 25px;
  text-align: center;

  .section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 0;
    padding-top: 20px 0 20px;
  }

  .logo-wrapper {
    width: 102px;
    height: 15px;
  }
}
</style>
